import { Inject, Injectable, forwardRef } from '@angular/core';
import { Http, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';

import { OrgNode, OrgNodeType } from '../../entities';
import { NumVisibleOrgNodes } from '../../entities/num-visible-org-nodes';

import { HttpClient } from './http-client.service';

import { Settings } from '../../settings';
import { DateConverter } from '../../utility/date-converter';
import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';
import { CachedCallService } from './cached-call.service';

@Injectable()
export class OrgNodeService {

  private static readonly orgNodeBaseUrl: string = `${Settings.apiUrl}/v1/OrgNodes`;

  protected cachedCallService: CachedCallService = new CachedCallService();

  constructor( @Inject(forwardRef(() => HttpClient)) private http: HttpClient) { }

  public getOrgNodeById(orgNodeId: string): Promise<OrgNode> {
    let orgNodeUrl: string = `${OrgNodeService.orgNodeBaseUrl}(${orgNodeId})`;

    return this.http.get(orgNodeUrl)
      .map(response => response.json())
      .toPromise();
  }

  public getDistrictOrgNodesByName(name: string, fiscalYearId: number, skip: number = 0): Promise<OrgNode[]> {
    let orgNodesByYearUrl: string = `${OrgNodeService.orgNodeBaseUrl}/RCC.GetOrgNodesByYear(FiscalYearId=${fiscalYearId})/`
    let oDataBuilder: ODataBuilder = new ODataBuilder(orgNodesByYearUrl);

    oDataBuilder
      .filter("OrgNodeTypeId", ODataComparer.Equals, OrgNodeType.DISTRICT)
      .filter("Name", ODataComparer.Contains, name)
      .top(100)
      .skip(skip)
      .orderBy("Name")
      .select(["OrgNodeId", "OrgNodeTypeId", "Name", "MemberCount", "ClubCount", "IsDerived"]);

    let orgNodeUrl: string = oDataBuilder.toString();
    return this.http.get(orgNodeUrl)
      .toPromise()
      .then(response => {
        return response.json().value;
      });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/org-node.service.ts